<template>
	<BlockUI :blocked="blocked">
		<div class="p-component p-fluid p-input-filled p-formgrid p-grid p-px-2">
<!--			<div class="p-field p-col-12 p-text-left">
				<label for="login">{{ $t('System-Administration.Login.Login') }} *</label>
				<InputText id="login" v-model.trim="v$.login.$model" :class="{'p-invalid':v$.login.$invalid && showErrorMessage}" @change="update" @keydown="onKeyDown" required="true" autofocus />
				<small v-if="v$.login.$invalid && showErrorMessage" class="p-error">
					{{ $t('Forms.Val.MissingRequired', { field: $t('System-Administration.Login.Login')}) }}
				</small>
			</div>-->
			<div class="p-field p-col-12 p-text-left">
				<label for="firstname">{{ $t('System-Administration.Login.Firstname') }} *</label>
				<InputText id="firstname" v-model.trim="v$.firstname.$model" :class="{'p-invalid':v$.firstname.$invalid && showErrorMessage}" @change="update" @keydown="onKeyDown" required="true" autofocus />
				<small v-if="v$.firstname.$invalid && showErrorMessage" class="p-error">
					{{ $t('Forms.Val.MissingRequired', { field: $t('System-Administration.Login.Firstname')}) }}
				</small>
			</div>
			<div class="p-field p-col-12 p-text-left">
				<label for="lastname">{{ $t('System-Administration.Login.Lastname') }} *</label>
				<InputText id="lastname" v-model.trim="v$.lastname.$model" :class="{'p-invalid':v$.lastname.$invalid && showErrorMessage}" @change="update" @keydown="onKeyDown" required="true" autofocus />
				<small v-if="v$.lastname.$invalid && showErrorMessage" class="p-error">
					{{ $t('Forms.Val.MissingRequired', { field: $t('System-Administration.Login.Lastname')}) }}
				</small>
			</div>
			<div class="p-field p-col-12 p-text-left">
				<label for="email">{{ $t('System-Administration.Login.Email') }} *</label>
				<InputText id="email" v-model.trim="v$.email.$model" :class="{'p-invalid':v$.email.$invalid && showErrorMessage}" @change="update" @keydown="onKeyDown" required="true" autofocus />
				<small v-if="v$.email.required.$invalid && showErrorMessage" class="p-error">
					{{ $t('Forms.Val.MissingRequired', { field: $t('System-Administration.Login.Email')}) }}
				</small><br/>
				<small v-if="v$.email.email.$invalid && showErrorMessage" class="p-error">
					{{$t('Forms.Val.Email')}}
				</small>
			</div>
			<div class="p-field p-col-12 p-text-left">
				<label for="password">{{$t('System-Administration.Login.Password')}} *</label>
				<Password
					id="password"
					v-model.trim="v$.password.$model"
					:class="{'p-invalid':v$.password.$invalid && showErrorMessage}"
					required
					:feedback="false"
					@change="update"
					@keydown="onKeyDown"
					v-tooltip.bottom="passwordValidationRules"
				/>
				<small v-if="v$.password.$invalid && showErrorMessage && v$.password.passwordLengthValidation && !v$.password.passwordLengthValidation.$invalid" class="p-error">
					{{ $t('Forms.Val.MissingRequired', { field: $t('System-Administration.Login.Password')}) }} <br/>
				</small>
				<small v-if="v$.password.passwordLengthValidation && v$.password.passwordLengthValidation.$invalid && showErrorMessage && v$.password.minOneLowerAndUpperCaseValidation && !v$.password.minOneLowerAndUpperCaseValidation.$invalid" class="p-error">
					{{ $t('Forms.Val.PasswordLength') }} <br/>
				</small>
				<small v-if="v$.password.minOneLowerAndUpperCaseValidation && v$.password.minOneLowerAndUpperCaseValidation.$invalid && showErrorMessage && v$.password.atLeastOneNumberValidation && !v$.password.atLeastOneNumberValidation.$invalid" class="p-error">
					{{ $t('Forms.Val.MinOneLowerAndUpperCase', { field: $t('Squeeze.Login.Password')}) }} <br/>
				</small>
				<small v-if="v$.password.atLeastOneNumberValidation && v$.password.atLeastOneNumberValidation.$invalid && showErrorMessage && v$.password.atLeastOneSpecialCharacterValidation && !v$.password.atLeastOneSpecialCharacterValidation.$invalid" class="p-error">
					{{ $t('Forms.Val.AtLeastOneNumber', { field: $t('Squeeze.Login.Password')}) }} <br/>
				</small>
				<small v-if="v$.password.atLeastOneSpecialCharacterValidation && v$.password.atLeastOneSpecialCharacterValidation.$invalid && showErrorMessage" class="p-error">
					{{ $t('Forms.Val.AtLeastOneSpecialCharacter', { field: $t('Squeeze.Login.Password')}) }} <br/>
				</small>
			</div>
			<div class="p-field p-col-12 p-text-left">
				<label for="passwordRepeat">{{$t('System-Administration.Login.PasswordRepeat')}} *</label>
				<Password id="passwordRepeat" v-model.trim="v$.passwordRepeat.$model" :class="{'p-invalid': v$.passwordRepeat.$invalid && showErrorMessage}" required :feedback="false" @change="update" @keydown="onKeyDown" />
				<small v-if="v$.passwordRepeat.required.$invalid && showErrorMessage" class="p-error">
					{{ $t('Forms.Val.MissingRequired', { field: $t('System-Administration.Login.PasswordRepeat')}) }}
					<br/>
				</small>
				<small v-if="v$.passwordRepeat.sameAsPassword.$invalid && showErrorMessage" class="p-error">
					{{ $t('System-Administration.Login.PasswordRepeatMessage') }}
				</small>
			</div>

			<div class="p-col-12 p-mt-2 p-text-right">
				<Button icon="mdi mdi-arrow-right" class="p-button-rounded p-button-outlined" @click="goToNextStep"/>
			</div>
		</div>
	</BlockUI>
</template>

<script lang="ts">
import {computed, defineComponent, onMounted, reactive, ref, watch} from 'vue';
import { useI18n } from 'vue-i18n';
import Password from 'primevue/password';
import InputText from 'primevue/inputtext';
import Button from "primevue/button";
import BlockUI from 'primevue/blockui';
import {email, required, sameAs} from "@vuelidate/validators";
import {useVuelidate} from "@vuelidate/core";
import {
	atLeastOneNumberValidation,
	atLeastOneSpecialCharacterValidation,
	minOneLowerAndUpperCaseValidation,
	passwordLengthValidation
} from "@/util/ValidationHelper";

export default defineComponent({
	name: "ProcessItemAdminUser",
	components: {
		Password,
		InputText,
		Button,
		BlockUI,
	},
	props: {
		adminUser: {
			type: Object,
		},
	},
	emits: ['update', 'goToPreviousOrNextStep'],
	setup(props, {emit}) {
		const {t} = useI18n();

		/** Current Object of all input-fields */
		const value = reactive<any>(props.adminUser);

		/** Determines the required rules for validation */
		const rules = {
			//login: { required },
			firstname: { required },
			lastname: { required },
			email: { required, email },
			password: {
				required,
				passwordLengthValidation,
				minOneLowerAndUpperCaseValidation,
				atLeastOneNumberValidation,
				atLeastOneSpecialCharacterValidation,
			},
			passwordRepeat: {  required, sameAsPassword: sameAs(computed(()=> value.password)) },
		}

		/** Use Vuelidate */
		const v$ = useVuelidate(rules, value);

		/** Is loading? */
		const loading = ref<boolean>(false);

		/** Should the ui be blocked? */
		const blocked = ref<boolean>(false);

		/** Triggered when (all) field values are invalid */
		const showErrorMessage = ref<boolean>(false);

		/** String with all password validation rules */
		const passwordValidationRules = t('Squeeze.Login.PasswordMustInclude') +
			' \n - ' + t('Forms.Val.PasswordLength') +
			' \n - ' + t('Forms.Val.MinOneLowerAndUpperCase', { field: t('Squeeze.Login.Password')}) +
			' \n - ' + t('Forms.Val.AtLeastOneNumber', { field: t('Squeeze.Login.Password')}) +
			' \n - ' + t('Forms.Val.AtLeastOneSpecialCharacter', { field: t('Squeeze.Login.Password')});

		/** Triggered on click */
		const goToNextStep = () => {
			if(v$.value.$invalid) {
				showErrorMessage.value = true;
				return
			}
			emit('goToPreviousOrNextStep', 1);
		}

		/** Triggered on change of any field */
		const update = () => {
			emit("update", value, v$.value.$invalid);
		}

		/**
		 * Triggered on keypress
		 * @param event
		 */
		const onKeyDown = (event: {key: string}) => {
			if (event.key === "Enter") {
				goToNextStep();
			}
		}

		/** Watch prop at set value object, because props are not allowed to be mutated */
		watch(() => props.adminUser, () => {
			Object.assign(value, props.adminUser);
			emit("update", value, v$.value.$invalid);
		})

		onMounted(async () => {
			Object.assign(value, props.adminUser);

			// Emit Validated-Values onMounted. Otherwise there can be validation-errors when editing multiple entries
			await v$.value.$validate();
			emit("update", value, v$.value.$invalid);
		});

		return {
			t,
			v$,
			loading,
			blocked,
			showErrorMessage,
			passwordValidationRules,
			goToNextStep,
			update,
			onKeyDown,
		}
	},
})
</script>

<style scoped>

.button-container {
	padding-left: 0;
	padding-right: 0;
}

</style>


